import { Pipe, PipeTransform } from '@angular/core';
import { fas, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { IconName } from "@fortawesome/free-regular-svg-icons";
import { findIconDefinition, library } from "@fortawesome/fontawesome-svg-core";
import { ErrorTracingService, TraceSeverity } from "libraries/service/error-tracing/error-tracing.service";

/**
 * Gets Icon Definition from its name.
 * Warning: please prefer use the normal way with <fa-icon>
 */
@Pipe({
    name: 'iconNameToDefinition'
})
export class IconNameToDefinitionPipe implements PipeTransform {

    constructor(private readonly errorTracingService: ErrorTracingService) {
    }

    public transform(value: string): IconDefinition {
        if(!value){
            return null;
        }
        library.add(fas);
        const iconName: IconName = value
            .split('-')
            .reduce((finalString: string, part: string, index: number): string => {
                if (index === 0 && part === 'fa') {
                    return '';
                }
                if (index === 0 && part === 'fa fa') {
                    return '';
                }
                if (finalString.length === 0) {
                    return part;
                }
                return `${finalString}-${part}`;
            }, '') as IconName;
        const iconDefinition: IconDefinition = findIconDefinition({iconName, prefix: "fas"});
        if (!(iconDefinition?.icon)) {
            this.errorTracingService.captureMessage(`Can't find icon definition for string ${value}`, TraceSeverity.Warning);
        }
        return iconDefinition;
    }
}
